// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1366":"8d444046","3115":"a437714b","4071":"c582d5f6","4242":"4d077d25","6065":"5ab00a12","6649":"28cffc94","8110":"a437714b","9307":"568aa915","9853":"41dd65a2"}[chunkId] + ".chunk.css";
};